import '../styles/EditDueDateDialog.css'
import closeIcon from '../images/close-icon.svg'
import DatePickerInput from './DatePickerInput'
import { useEffect, useState } from 'react';
import { StudentCardProps2 } from './IndividualStudentCard';
import { IndividualGoalType } from './IndividualGoal';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import LinearProgressBar from './LinearProgressBar';
import SnackbarAlert from './SnackbarAlert';

interface EditDueDateDialogProps {
    goalId: number
    goalList: IndividualGoalType[]
    studentList: StudentCardProps2[]
    setStudentList: any;
    handleClickClose: () => void
    isScholarship: boolean;
}

export default function EditDueDateDialog({ goalId, goalList, studentList, setStudentList, handleClickClose, isScholarship }: EditDueDateDialogProps) {

    const [cookies] = useCookies(['user'])
    const [selectedDate, setSelectedDate] = useState<null | moment.Moment>(null);
    const [loading, setLoading] = useState(false)

    const goal = goalList?.find(goal => goal.id === goalId)
    const goalName = goal?.goal || goal?.name

    const [progressIdList, setProgressIdList] = useState<number[]>([])

    const [snackbarMessage, setSnackbarMessage] = useState<null | {
        message: string,
        severity?: 'success' | 'info' | 'warning' | 'error',
        autoHideDuration?: number | null
    }>(null)

    useEffect(() => {
        if (studentList) {
            setStudentList((prev: StudentCardProps2[]) => {
                return [...prev].sort((a, b) => {
                    return (a.id).localeCompare(b.id)
                })
            })
            if (isScholarship) {
                setProgressIdList(studentList.map(student => student.scholarshipProgressId!))
            } else {
                setProgressIdList(studentList.map(student => student.individualProgressId!))
            }
        }
    }, [])

    const changeDateFormat = (date: null | string) => {
        if (date === null) {
            return null
        }
        const newDate = new Date(date)
        return newDate.toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: 'Asia/Bangkok'
        })
    }

    const fetchURL = isScholarship ? `/ScholarshipProgresses/progresses` : `/IndividualProgresses/progresses`

    const handleEditDueDate = () => {
        if (selectedDate && progressIdList.length > 0) {
            setLoading(true)
            setSnackbarMessage(null)
            const body = {
                progressList: progressIdList,
                deadline: selectedDate,
                staffId: cookies.user.staffId
            }
            axios.put(fetchURL, body, {
                headers: {
                    'Authorization': `Bearer ${cookies?.user?.token}`
                },
                withCredentials: true
            }).then(res => {
                
                setSnackbarMessage({
                    message: 'Edit Due Date Success!',
                    severity: 'success',
                    autoHideDuration: 1500
                })
                setTimeout(() => {
                    setLoading(false)
                    handleClickClose()
                }, 2000)
            }).catch(err => {
                
                setSnackbarMessage({
                    message: 'Edit Due Date Failed! Please try again later.',
                    severity: 'error',
                    autoHideDuration: 3000
                })
                setLoading(false)
            })
        }
    }

    return (
        <div className="EditDueDateDialog">
            <div className="EditDueDateDialog-dialog">
                <button className="ProgressDialog-close-button" onClick={handleClickClose}>
                    <img src={closeIcon} width={24} height={24} alt="close-icon" />
                </button>
                {
                    (loading) &&
                    <div className="ProgressDialog-linear-progress">
                        <LinearProgressBar />
                    </div>
                }
                <div className="AddStudentDialog-header-container">
                    <h4 className='AddStudentDialog-title'>Edit Due Date</h4>
                    <h4 className='AddStudentDialog-goal-name'>{goalName}</h4>
                </div>
                <div className='EditDueDateDialog-deadline'>
                    <DatePickerInput
                        label='New Due Date'
                        emptyLabel='Select Date'
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        disabled={loading}
                        inputVariant="outlined"
                        required
                        style={
                            {
                                padding: '15px 14px',
                            }
                        }
                    />
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Student ID</th>
                            <th scope="col">Student Name</th>
                            <th scope="col">Current Due Date</th>
                            <th scope="col">New Due Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            studentList.map(({ id, title, firstName, lastName, deadline }: StudentCardProps2) => {
                                return (
                                    <tr key={id}>
                                        <td>{id}</td>
                                        <td>{title} {firstName} {lastName}</td>
                                        <td>{changeDateFormat(deadline) || ''}</td>
                                        <td>{changeDateFormat(selectedDate?.format('YYYY-MM-DD') || null) || ''}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                <div className="ProgressDialog-bottom-container" >
                    <div className="ProgressDialog-actions" style={{ marginLeft: 'auto' }}>
                        <button className="ProgressDialog-button" onClick={handleClickClose}>Cancel</button>
                        <button className="ProgressDialog-button" onClick={handleEditDueDate} disabled={selectedDate === null || loading}>Edit</button>
                    </div>
                </div>
            </div>
            {
                (snackbarMessage) &&
                <SnackbarAlert severity={snackbarMessage.severity} message={snackbarMessage.message} />
            }
        </div>
    )
}